// SPDX-License-Identifier: MIT
// incr.4b §5.8 (spec Appendix D.1) — guided-run chrome slimming.
// Pure DOM class toggling, extracted for unit-testability. welcome.ts calls
// this at the guidedRun latch: the header is a full-bleed SIBLING of
// .welcome-page (not a child), so one ancestor class can't cover both —
// toggle a class on each captured root; src/styles/chrome.css does the rest.
export function applyGuidedChrome(
  els: { header?: Element | null; page?: Element | null },
  guided: boolean,
): void {
  els.header?.classList.toggle('site-header--guided', guided);
  els.page?.classList.toggle('welcome-page--guided', guided);
}
